import React from "react";

const cards = [
  { key: "total", label: "Total docentes", icon: "bi bi-people", accent: "" },
  { key: "activos", label: "Activos", icon: "bi bi-check-circle", accent: "success" },
  { key: "inactivos", label: "Inactivos", icon: "bi bi-slash-circle", accent: "neutral" },
];

export default function DocentesSummary({ resumen = {}, onQuickFilter, activeKey }) {
  const handleKey = (key) => onQuickFilter?.(key);

  return (
    <div className="management-card mb-4">
      <div className="docentes-summary-grid">
        {cards.map((card) => {
          const isActive = activeKey === card.key;
          const accentClass = card.accent ? `accent-${card.accent}` : "";
          return (
            <div key={card.key} className="w-100">
              <div
                className={`management-stat-card docentes-summary-card h-100 ${accentClass} ${isActive ? "active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => handleKey(card.key)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleKey(card.key);
                  }
                }}
              >
                <div className="management-stat-icon">
                  <i className={card.icon} />
                </div>
                <div>
                  <p className="management-stat-label mb-1">{card.label}</p>
                  <div className="management-stat-value">{resumen[card.key] ?? 0}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
